import React, { useState } from "react";
import AuthModal from "./AuthModal";
import "../App.css";
import { Button } from "./Button";
import "./HeroSection.css";
import { useHistory } from "react-router-dom";
import { useAuth } from "../services/authContext";

function HeroSection() {
  const history = useHistory();
  const { user } = useAuth();

  const handleCategoryClick = (gender) => {
    history.push(`/services?gender=${gender}`);
  };

  return (
    <div className="hero-container">
      <video src="/videos/video-1.mp4" autoPlay loop muted playsInline>
        <source src="/videos/video-1.mp4" type="video/mp4" />
        <source src="/videos/video-1.webm" type="video/webm" />
        <source src="/videos/video-1.ogv" type="video/ogg" />
        Your browser does not support the video tag.
      </video>
      <h1>BEST DEALS</h1>
      {user && user.firstName && (
        <div style={{ margin: '16px 0', fontSize: '1.3rem', color: '#fff', fontWeight: 500, textShadow: '0 1px 4px #000' }}>
          Welcome, {user.firstName}!
        </div>
      )}
      <p>
        Pick your favorite brands, sizes, and categories. We tailor results for you!
      </p>
      <div className="hero-btns">
        <Button
          className="btns"
          buttonStyle="btn--outline"
          buttonSize="btn--large"
          onClick={() => handleCategoryClick("MENS")}
        >
          SHOP MENS
        </Button>
        <Button
          className="btns"
          buttonStyle="btn--outline"
          buttonSize="btn--large"
          onClick={() => handleCategoryClick("WOMENS")}
        >
          SHOP WOMENS
        </Button>
      </div>
    </div>
  );
}

export default HeroSection;
